import 'babel-polyfill'

require([
    'JBrowse/Browser',
    'JBrowse/Util',
    'JBrowse/QueryParamConfigMapper',
    'dojo/io-query',
    'dojo/json',
    'css!../../css/genome.scss',

    // instruct build/glob-loader.js to insert includes for every bit of JBrowse and plugin code
     'JBrowse/View/TrackList/Simple',
 'JBrowse/View/TrackList/Null',
 'JBrowse/View/TrackList/Hierarchical',
 'JBrowse/View/TrackList/Faceted',
 'JBrowse/View/TrackList/_TextFilterMixin',
 'JBrowse/View/TrackConfigEditor',
 'JBrowse/View/Track/WiggleBase',
 'JBrowse/View/Track/Wiggle/XYPlot',
 'JBrowse/View/Track/Wiggle/Density',
 'JBrowse/View/Track/Wiggle/_Scale',
 'JBrowse/View/Track/Wiggle',
 'JBrowse/View/Track/SNPCoverage',
 'JBrowse/View/Track/Sequence',
 'JBrowse/View/Track/LocationScale',
 'JBrowse/View/Track/HTMLVariants',
 'JBrowse/View/Track/HTMLFeatures',
 'JBrowse/View/Track/GridLines',
 'JBrowse/View/Track/FixedImage/Wiggle',
 'JBrowse/View/Track/FixedImage',
 'JBrowse/View/Track/FeatureCoverage',
 'JBrowse/View/Track/Combination/CombinationDialog',
 'JBrowse/View/Track/Combination',
 'JBrowse/View/Track/CanvasVariants',
 'JBrowse/View/Track/CanvasFeatures',
 'JBrowse/View/Track/BlockBased/Block',
 'JBrowse/View/Track/BlockBased',
 'JBrowse/View/Track/Alignments2',
 'JBrowse/View/Track/Alignments',
 'JBrowse/View/Track/_YScaleMixin',
 'JBrowse/View/Track/_VariantDetailMixin',
 'JBrowse/View/Track/_TrackDetailsStatsMixin',
 'JBrowse/View/Track/_NamedFeatureFiltersMixin',
 'JBrowse/View/Track/_FeatureDetailMixin',
 'JBrowse/View/Track/_FeatureContextMenusMixin',
 'JBrowse/View/Track/_ExportMixin',
 'JBrowse/View/Track/_AlignmentsMixin',
 'JBrowse/View/StandaloneDatasetList',
 'JBrowse/View/Ruler',
 'JBrowse/View/LocationList',
 'JBrowse/View/LocationChoiceDialog',
 'JBrowse/View/InfoDialog',
 'JBrowse/View/GranularRectLayout',
 'JBrowse/View/FileDialog/TrackList/VCFTribbleDriver',
 'JBrowse/View/FileDialog/TrackList/VCFTabixDriver',
 'JBrowse/View/FileDialog/TrackList/TwoBitDriver',
 'JBrowse/View/FileDialog/TrackList/IndexedFASTADriver',
 'JBrowse/View/FileDialog/TrackList/GTFDriver',
 'JBrowse/View/FileDialog/TrackList/GFF3TabixDriver',
 'JBrowse/View/FileDialog/TrackList/GFF3Driver',
 'JBrowse/View/FileDialog/TrackList/CRAMDriver',
 'JBrowse/View/FileDialog/TrackList/BigWigDriver',
 'JBrowse/View/FileDialog/TrackList/BigBedDriver',
 'JBrowse/View/FileDialog/TrackList/BEDTabixDriver',
 'JBrowse/View/FileDialog/TrackList/BEDDriver',
 'JBrowse/View/FileDialog/TrackList/BAMDriver',
 'JBrowse/View/FileDialog/TrackList/_OptionallyIndexedFileDriver',
 'JBrowse/View/FileDialog/TrackList/_MultiIndexedFileDriver',
 'JBrowse/View/FileDialog/TrackList/_IndexedFileDriver',
 'JBrowse/View/FileDialog/TrackList',
 'JBrowse/View/FileDialog/ResourceList',
 'JBrowse/View/FileDialog',
 'JBrowse/View/FeatureGlyph/UCSC/BED',
 'JBrowse/View/FeatureGlyph/Segments',
 'JBrowse/View/FeatureGlyph/ProcessedTranscript',
 'JBrowse/View/FeatureGlyph/Gene',
 'JBrowse/View/FeatureGlyph/Diamond',
 'JBrowse/View/FeatureGlyph/Box',
 'JBrowse/View/FeatureGlyph/Alignment',
 'JBrowse/View/FeatureGlyph/_FeatureLabelMixin',
 'JBrowse/View/FeatureGlyph',
 'JBrowse/View/FastaFileDialog',
 'JBrowse/View/FASTA',
 'JBrowse/View/Export/Wiggle',
 'JBrowse/View/Export/SequinTable',
 'JBrowse/View/Export/GFF3',
 'JBrowse/View/Export/FASTA',
 'JBrowse/View/Export/bedGraph',
 'JBrowse/View/Export/BED',
 'JBrowse/View/Export',
 'JBrowse/View/Dialog/WithActionBar',
 'JBrowse/View/Dialog/SetTrackHeight',
 'JBrowse/View/Dialog/SetHighlight',
 'JBrowse/View/Dialog/Search',
 'JBrowse/View/Dialog/QuickHelp',
 'JBrowse/View/Dialog/Preferences',
 'JBrowse/View/Dialog/OpenDirectory',
 'JBrowse/View/DetailsMixin',
 'JBrowse/View/ConfirmDialog',
 'JBrowse/View/Animation/Zoomer',
 'JBrowse/View/Animation/Slider',
 'JBrowse/View/Animation',
 'JBrowse/View/_FeatureDescriptionMixin',
 'JBrowse/Util/TextIterator',
 'JBrowse/Util/RejectableFastPromise',
 'JBrowse/Util/GTF',
 'JBrowse/Util/FeatureFilters',
 'JBrowse/Util/FastPromise',
 'JBrowse/Util/dot-object',
 'JBrowse/Util',
 'JBrowse/Track',
 'JBrowse/TouchScreenSupport',
 'JBrowse/Store/TribbleIndexedFile',
 'JBrowse/Store/TrackMetaData',
 'JBrowse/Store/TiledImage/Fixed',
 'JBrowse/Store/TiledImage/Fixed_v0',
 'JBrowse/Store/TabixIndexedFile',
 'JBrowse/Store/Sequence/TwoBit',
 'JBrowse/Store/Sequence/StaticChunked',
 'JBrowse/Store/Sequence/IndexedFasta',
 'JBrowse/Store/SeqFeature/VCFTribble',
 'JBrowse/Store/SeqFeature/VCFTabix',
 'JBrowse/Store/SeqFeature/VCF/Parser',
 'JBrowse/Store/SeqFeature/VCF/LazyFeature',
 'JBrowse/Store/SeqFeature/UnindexedFasta/File',
 'JBrowse/Store/SeqFeature/UnindexedFasta',
 'JBrowse/Store/SeqFeature/TwoBit',
 'JBrowse/Store/SeqFeature/SPARQL',
 'JBrowse/Store/SeqFeature/SNPCoverage',
 'JBrowse/Store/SeqFeature/SequenceChunks',
 'JBrowse/Store/SeqFeature/REST',
 'JBrowse/Store/SeqFeature/QuantitativeCombination',
 'JBrowse/Store/SeqFeature/NCList',
 'JBrowse/Store/SeqFeature/NCList_v0',
 'JBrowse/Store/SeqFeature/Mask',
 'JBrowse/Store/SeqFeature/IndexedFasta/File',
 'JBrowse/Store/SeqFeature/IndexedFasta',
 'JBrowse/Store/SeqFeature/GTF/Parser',
 'JBrowse/Store/SeqFeature/GTF',
 'JBrowse/Store/SeqFeature/GlobalStatsEstimationMixin',
 'JBrowse/Store/SeqFeature/GFF3Tabix',
 'JBrowse/Store/SeqFeature/GFF3',
 'JBrowse/Store/SeqFeature/FromConfig',
 'JBrowse/Store/SeqFeature/CRAM',
 'JBrowse/Store/SeqFeature/Coverage',
 'JBrowse/Store/SeqFeature/CombinationBase',
 'JBrowse/Store/SeqFeature/Combination',
 'JBrowse/Store/SeqFeature/BigWig/Window',
 'JBrowse/Store/SeqFeature/BigWig/RequestWorker',
 'JBrowse/Store/SeqFeature/BigWig',
 'JBrowse/Store/SeqFeature/BigBed',
 'JBrowse/Store/SeqFeature/BEDTabix',
 'JBrowse/Store/SeqFeature/BED/Parser',
 'JBrowse/Store/SeqFeature/BED',
 'JBrowse/Store/SeqFeature/BAMCombination',
 'JBrowse/Store/SeqFeature/BAM/Util',
 'JBrowse/Store/SeqFeature/BAM/LazyFeature',
 'JBrowse/Store/SeqFeature/BAM/File',
 'JBrowse/Store/SeqFeature/BAM',
 'JBrowse/Store/SeqFeature/_MismatchesMixin',
 'JBrowse/Store/SeqFeature',
 'JBrowse/Store/RemoteBinaryFile',
 'JBrowse/Store/NCList',
 'JBrowse/Store/NCList_v0',
 'JBrowse/Store/Names/REST',
 'JBrowse/Store/Names/LazyTrieDojoData',
 'JBrowse/Store/Names/Hash',
 'JBrowse/Store/LRUCache',
 'JBrowse/Store/LazyTrie',
 'JBrowse/Store/LazyArray',
 'JBrowse/Store/Hash',
 'JBrowse/Store/DeferredStatsMixin',
 'JBrowse/Store/DeferredFeaturesMixin',
 'JBrowse/Store/BigWig',
 'JBrowse/Store',
 'JBrowse/QueryParamConfigMapper',
 'JBrowse/Plugin',
 'JBrowse/Model/XHRBlob',
 'JBrowse/Model/TribbleIndex',
 'JBrowse/Model/TabixIndex',
 'JBrowse/Model/SimpleFeature',
 'JBrowse/Model/Range',
 'JBrowse/Model/NestedFrequencyTable',
 'JBrowse/Model/modEncodeTrackMetadata',
 'JBrowse/Model/Location',
 'JBrowse/Model/FileBlob',
 'JBrowse/Model/DataView',
 'JBrowse/Model/CSIIndex',
 'JBrowse/Model/CoverageFeature',
 'JBrowse/Model/BlobFilehandleWrapper',
 'JBrowse/Model/BinaryTreeNode',
 'JBrowse/Model/BGZip/VirtualOffset',
 'JBrowse/Model/BGZip/BGZBlob',
 'JBrowse/Model/BAIIndex',
 'JBrowse/Model/ArrayRepr',
//SKIPPED  'JBrowse/main',
 'JBrowse/has',
 'JBrowse/GenomeView',
 'JBrowse/Finisher',
 'JBrowse/FeatureFiltererMixin',
 'JBrowse/Errors',
 'JBrowse/Digest/Crc32',
 'JBrowse/ConfigManager',
 'JBrowse/ConfigAdaptor/JB_json_v1',
 'JBrowse/ConfigAdaptor/JB_json_v0',
 'JBrowse/ConfigAdaptor/conf',
 'JBrowse/ConfigAdaptor/AdaptorUtil',
 'JBrowse/Component',
 'JBrowse/CodonTable',
 'JBrowse/Browser',
 'JBrowse/BehaviorManager',
 'RegexSequenceSearch/View/SearchSeqDialog',
 'RegexSequenceSearch/Store/SeqFeature/RegexSearch',
 'RegexSequenceSearch/main',
 'NeatHTMLFeatures/View/Track/NeatFeatures',
 'NeatHTMLFeatures/main',
 'NeatCanvasFeatures/View/Track/NeatFeatures',
 'NeatCanvasFeatures/View/FeatureGlyph/Segments',
 'NeatCanvasFeatures/View/FeatureGlyph/ProcessedTranscript',
 'NeatCanvasFeatures/View/FeatureGlyph/Gene',
 'NeatCanvasFeatures/View/FeatureGlyph/Box',
 'NeatCanvasFeatures/main',
 'HideTrackLabels/main',
 'FeatureSequence/View/FeatureSequenceOld',
 'FeatureSequence/View/FeatureSequence',
 'FeatureSequence/main',
 'DebugEvents/main',
 'CategoryUrl/main',

],
function (
    Browser,
    Util,
    QueryParamConfigMapper,
    ioQuery,
    JSON,
    conf
) {
    // the initial configuration of this JBrowse
    // instance

    // NOTE: this initial config is the same as any
    // other JBrowse config in any other file.  this
    // one just sets defaults from URL query params.
    // If you are embedding JBrowse in some other app,
    // you might as well just set this initial config
    // to something like { include: '../my/dynamic/conf.json' },
    // or you could put the entire
    // dynamically-generated JBrowse config here.

    // parse the query vars in the page URL
    var queryParams = ioQuery.queryToObject( window.location.search.slice(1) );

    var config = {
        containerID: "GenomeBrowser",

        dataRoot: queryParams.data,
        queryParams: queryParams,
        location: queryParams.loc,
        forceTracks: queryParams.tracks,
        initialHighlight: queryParams.highlight,
        show_nav: queryParams.nav,
        show_tracklist: queryParams.tracklist,
        show_overview: queryParams.overview,
        show_menu: queryParams.menu,
        show_fullviewlink: queryParams.fullviewlink,
        show_tracklabels: queryParams.tracklabels,
        update_browser_title: queryParams.browsertitle,
        highResolutionMode: queryParams.highres,
        stores: { url: { type: "JBrowse/Store/SeqFeature/FromConfig", features: [] } },
        bookmarks: { },
        makeFullViewURL: function( browser ) {

            // the URL for the 'Full view' link
            // in embedded mode should be the current
            // view URL, except with 'nav', 'tracklist',
            // and 'overview' parameters forced to 1.

            return browser.makeCurrentViewURL({ nav: 1, tracklist: 1, overview: 1 });
        },
        updateBrowserURL: true,
        electronData: queryParams.electronData || (Util.isElectron() && electronRequire('electron').remote.app.getPath('userData'))
    };

    window.addEventListener('load', () => {
        // see if we can load some configuration from the data-config attribute of our container
        try {
            let elementConfig = document.getElementById(config.containerID).getAttribute('data-config')
            if (elementConfig) {
                if (!/^\s*{/.test(elementConfig)) elementConfig = `{${elementConfig}}`
                elementConfig = JSON.parse(elementConfig)
                config = Object.assign({},config,elementConfig)
            }
        } catch(e) {
            console.error(e)
        }

        //if there is ?addFeatures in the query params,
        //define a store for data from the URL
        if( queryParams.addFeatures ) {
            config.stores.url.features = JSON.parse( queryParams.addFeatures );
        }

        // if there is ?addTracks in the query params, add
        // those track configurations to our initial
        // configuration
        if( queryParams.addTracks ) {
            config.tracks = JSON.parse( queryParams.addTracks );
        }

        // if there is ?addBookmarks, add those to configuration
        if( queryParams.addBookmarks ) {
            config.bookmarks.features = JSON.parse( queryParams.addBookmarks );
        }

        // if there is ?addStores in the query params, add
        // those store configurations to our initial
        // configuration
        if( queryParams.addStores ) {
            config.stores = JSON.parse( queryParams.addStores );
        }

        // this handles dot notation versions of addTracks, addBookmarks, and addStores
        // see config doc for details
        QueryParamConfigMapper().handleQueryParams(config,queryParams);

        // create a JBrowse global variable holding the JBrowse instance
        window.JBrowse = new Browser( config );

        window.JBrowse.afterMilestone('loadRefSeqs', function() { dojo.destroy(dojo.byId('LoadingScreen')); });
    })
});




// WEBPACK FOOTER //
// ./src/JBrowse/main.js